angular
    .module('empower.control')
    .directive("mainnav", ['$rootScope', '$timeout', '$location', '$route', function ($rootScope, $timeout, $location, $route) {
        return function (scope, element, attrs) {
            element.bind("click", function () {
                $timeout(function () {
                    // prevent user access tile of not accept term and conditon
                    if ($rootScope.user && !$rootScope.user.IsAcceptTermCondition) {
                        return null;
                    }
                    
                    scope.$eval(attrs.actionclick);
                    
                    // set page name
                    if (attrs.pagename) {
                        $rootScope.pageName = attrs.pagename;
                    }

                    // if click standed path, clear history of policy and claim then reload
                    // otherwise, just navigate to that link
                    if(attrs.linkToGo) {
                        $rootScope.navigate(attrs.linkToGo);
                    }
                    
                }, 1000);
            });
        };
    }])
    .directive("backnav", [function () {
        return function (scope, element) {
            element.bind("click", function () {
                scope.$apply(function () {
                    window.history.back();
                });
            });
        };
    }]);
